import { LeasingType } from 'modules/types/LeasingOffer';
import { Flex, HeadlineTitle, Label, ParagraphTitle, theme } from 'modules/ui';
import styled from 'styled-components';

export const LeasingInstallmentContainer = styled(Flex)<{
  leasingType: LeasingType;
}>`
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 1.5rem;
  word-break: break-all;

  background-color: ${(props) =>
    props.leasingType === LeasingType.FINANCIAL
      ? props.theme.colors.primaryT6
      : props.theme.colors.primaryK8};

  ${HeadlineTitle} {
    color: ${(props) =>
      props.leasingType === LeasingType.FINANCIAL
        ? props.theme.colors.primaryT2
        : props.theme.colors.primaryK7};
  }
`;

export const StyledLabel = styled(Label)`
  color: ${({theme}) => theme.colors.primaryK10};
`;

export const StyledTitle = styled(ParagraphTitle)`
  color: ${({theme}) => theme.colors.primaryK10};
`;

export const StyledSubtitle = styled(ParagraphTitle)`
  color: ${({theme}) => theme.colors.primaryK4};
  margin-bottom: 0;
`;
